module.exports = __webpack_public_path__ + "img/t5.e5e1948c.png";